(function (app, ng) {

    app.filter("inDateRange",
        [
            "moment", function(moment) {
                return function(items, startDate, endDate) {
                    if (!startDate && !endDate)
                        return items;

                    return items.filter(function(item) {
                        return moment(item.StartDate).isBetween(startDate, endDate);
                    });
                }
            }
        ]);

})(window.app, window.angular); //jshint ignore:line